import React, { useState, useEffect } from "react";
import { getLocations } from "api";
//
import {
    Grid,
    Checkbox,
    Button,
    FormGroup,
    FormControl,
    FormControlLabel,
} from "@material-ui/core";
//
import { LocationAutoSuggest } from "containers/components/autoSuggest";

const LocationPicker = (props) => {
    const [locations, setLocations] = useState([]);
    const { locationShortcuts, onChange, error } = props;
    let locationListLastSelectedLocation = null;

    useEffect(() => {
        getLocations().then((locations) => {
            setLocations(locations);
            if (props.selectAll) {
                selectAllLocations();
            } else {
                deselectAllLocations();
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.selectAll]);

    const sortSelectedLocations = (locations) => {
        const selectedLocations = locations.filter(location => locationShortcuts.includes(location.shortcut));
        const unselectedLocations = locations.filter(location => !locationShortcuts.includes(location.shortcut));
        return [...selectedLocations, ...unselectedLocations];
    };

    const areAllLocationsSelected = () => {
        const projectsAndSelectedProjectsIntersection = locations.filter(
            (location) => !locationShortcuts.includes(location.shortcut)
        );

        return projectsAndSelectedProjectsIntersection.length === 0;
    };

    const isNoLocationSelected = () => locationShortcuts.length === 0;

    const selectLocations = (locations) => onChange(locations);

    const deselectAllLocations = () => selectLocations([]);

    const selectAllLocations = () => selectLocations(locations.map((location) => location.shortcut));

    const onLocationSelectionChange = (e, location) => {
        const selectionIndex = locationShortcuts.indexOf(location.shortcut);
        const isSelected = selectionIndex >= 0;

        const event = e.nativeEvent;
        if (event.shiftKey && locationListLastSelectedLocation) {
            const lastSelectedLocationIndex = locations.indexOf(
                locationListLastSelectedLocation
            );
            const index = locations.indexOf(location);

            const from = Math.min(lastSelectedLocationIndex, index);
            const to = Math.max(lastSelectedLocationIndex, index);

            let allSelected = true;
            for (let i = from; i <= to; i++) {
                if (i === lastSelectedLocationIndex) {
                    // last clicked location
                    continue;
                }

                if (!locationShortcuts.includes(locations[i].shortcut)) {
                    allSelected = false;
                    break;
                }
            }

            if (allSelected) {
                for (let i = from; i <= to; i++) {
                    const selectionIndex = locationShortcuts.indexOf(locations[i].shortcut);
                    if (selectionIndex >= 0) {
                        locationShortcuts.splice(selectionIndex, 1);
                    }
                }
            } else {
                for (let i = from; i <= to; i++) {
                    locationShortcuts.push(locations[i].shortcut);
                }
            }
        } else if (e.target.checked ^ isSelected) {
            if (e.target.checked) {
                locationShortcuts.push(location.shortcut);
            } else {
                locationShortcuts.splice(selectionIndex, 1);
            }
        }

        locationListLastSelectedLocation = location;

        const locationShortcutsDistinct = locationShortcuts.filter((item, pos, array) => array.indexOf(item) === pos);
        selectLocations(locationShortcutsDistinct);
    };

    return (
        <Grid container direction="column" spacing={3} className="picker-container">
            <Grid container item>
                <Grid item xs={12}>
                    <LocationAutoSuggest
                        label="Locations"
                        value={null}
                        fetchOptions={() => getLocations()}
                        onChange={(location) => {
                            if (!location) {
                                return;
                            }

                            const containsProject = locationShortcuts.includes(location.shortcut);
                            if (!containsProject) {
                                const newLocationShortcuts = [...locationShortcuts];
                                newLocationShortcuts.push(location.shortcut);
                                onChange(newLocationShortcuts);
                            }
                        }}
                        error={error}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormGroup className="item-list">
                        {sortSelectedLocations(locations).map((location) => (
                            <FormControl key={location.id} style={{ width: "100%" }}>
                                <FormControlLabel
                                    value={location.title}
                                    label={location.title}
                                    labelPlacement="end"
                                    className={
                                        locationListLastSelectedLocation === location
                                            ? "item--selected"
                                            : ""
                                    }
                                    control={
                                        <Checkbox
                                            onChange={(e) => onLocationSelectionChange(e, location)}
                                            checked={locationShortcuts.includes(location.shortcut)}
                                        />
                                    }
                                />
                            </FormControl>
                        ))}
                    </FormGroup>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={3} justifyContent="flex-end">
                    <Grid item>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => selectAllLocations()}
                            disabled={areAllLocationsSelected()}
                        >
                            SELECT ALL
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => deselectAllLocations()}
                            disabled={isNoLocationSelected()}
                        >
                            DESELECT ALL
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default LocationPicker;
